<template>
  <GridBase gak-global>
    <section class="top">
      <h1>
        <p>GAK<br />GLOBAL</p>
      </h1>
    </section>
    <section class="s1">
      <grid-base class="visual j">
        <h2><TextBlock file="dc/global-data-t2" class="pre-line" out-only /></h2>
      </grid-base>
      <TextBlock file="dc/global-data-t1" class="pre-line j" data-offset="100" />
    </section>
    <section class="s2">
      <h2>
        Global Region<br />
        Features
      </h2>
      <ul class="list">
        <li v-for="(item, id) in featureList" :key="id" @click="featureId = featureId === id ? null : id" :class="{ on: featureId === id }">
          <div class="item">
            <h3 v-html="item.title" />
            <h5 v-html="item.copy" />
          </div>
          <div class="over">
            <p v-html="item.exp" />
            <p>
              <span v-html="item.subExp01" ></span>
              <span v-html="item.subExp02" ></span>
            </p>
          </div>
        </li>
      </ul>
      <a href="https://www.ncloud.com" target="_blank">
        NAVER<br />
        Cloud Platform
        <Icon name="launch" />
      </a>
    </section>
    <section class="s3">
      <h2>
        Global Infra
      </h2>
      <div class="exp">
        <h4><TextBlock file="dc/global-data-t3" class="q pre-line" /></h4>
        <p class="q">
          We are expanding our cloud services to provide the best service quality and stable cloud services with more than 350 local network providers around key global locations.
        </p>
      </div>
      <div class="visual" ref="map">
        <div class="map">
          <p class="area">Region America</p>
          <p class="area">Region Europe</p>
          <p class="area">Region Asia</p>
          <ul>
            <li v-for="(item, id) in world" :key="id" :class="{ off: !item.active }" @mouseover="mapId = id" @mouseout="removeBalloon">
              <a>{{ item.name }}</a>
              <p />
              <p class="balloon hidden-sm-down" :class="`b${id}`" v-html="item.balloon" v-if="id === mapId && item.balloon" />
            </li>
          </ul>
        </div>
      </div>
      <div class="info">
        <p>Cloud service provided</p>
        <!-- <p class="off">Cloud service to be provided</p> -->
      </div>
      <div class="scroll__bar" ref="scrollBar">
          <div class="bar">
            <button 
              class="scroll__bar-controller"
              :style="{ left: controllerLeft + 'px' }"
              @mousedown="handleMouseStart"
              @mouseup="handleMouseUp"
              @mousemove="handleMouseMove"
              @touchstart="handleTouchStart"
              @touchend="handleTouchEnd"
              @touchmove="handleTouchMove"
              ref="controller"
            ></button>
          </div>
        </div>
      <p class="balloon hidden-md-up" v-html="mapExp" v-if="mapExp" />
      <!--      <div class="scroll q">-->
      <!--        <a class="handle"></a>-->
      <!--      </div>-->
    </section>
    <section class="s4">
      <h2>
        Global Region<br />
        Details
      </h2>
      <dl class="radio">
        <template v-for="(item, id) in serviceList">
          <dt :key="`dt${id}`" :class="{ on: radioOpen === id }" @click="radioOpen = radioOpen === id ? -1 : id">
            <s v-html="item.name" />
          </dt>
          <dd :key="`dd${id}`">
            <div>
              <p v-html="item.body" />
              <span v-html="item.bodyBottom" />
              <span v-html="item.subText" class="sub"/>
            </div>
          </dd>
        </template>
      </dl>
      <ul class="items">
        <li v-for="(item, id) in serviceList" :key="id" v-html="item.name" :class="{ on: serviceId === id }" @click="serviceId = id" />
      </ul>
      <div class="exp">
        <h3 v-html="currentService.name" />
        <div>
          <p v-html="currentService.body" />
          <p v-html="currentService.bodyBottom" />
        </div>
        <p v-html="currentService.subText" class="sub"/>
      </div>
    </section>
    <article class="bottom">
      <GridBase b50>
        <TextBlock file="dc/global-data-t4" class="q pre-line" />
        <p class="q">Beyond GAK Chuncheon and GAK Sejong, we provide world-class technology and services based on data centers built in major locations around the world, and present a new alternative in the global IT ecosystem.</p>
      </GridBase>
      <quick-link>
        <quick-link-item type="gray"><a class="launch" target="_blank" href="https://ncloud.com/solution/featured/globalService"><span>Go to NAVER Cloud Platform <br />  global services</span></a></quick-link-item>
      </quick-link>
    </article>
    <!-- <quick-link>
      <quick-link-item
        ><router-link to="/tech/technology">NAVER <br />CLOUD PLATFORM</router-link></quick-link-item
      >
      <quick-link-item><router-link to="/archive/tech-talk">Tech Talk</router-link></quick-link-item>
    </quick-link> -->
  </GridBase>
</template>
<script>
import GridBase from '@/views/components/GridBase';
import Icon from '@/views/components/Icon';
import feature from '@/data/gak/globalFeatureEN';
import service from '@/data/gak/globalServiceEN';
import TextBlock from '@/views/components/TextBlock';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';

export default {
  components: { QuickLinkItem, QuickLink, TextBlock, Icon, GridBase },
  computed: {
    featureList() {
      return feature;
    },
    mapExp() {
      if (this.mapId < 0) return false;
      return this.world[this.mapId].balloon;
    },
    serviceList() {
      return service;
    },
    currentService() {
      return service[this.serviceId];
    }
  },
  methods: {
    removeBalloon() {
      this.mapId = -1;
    },
    calculateMaxLeft() {
      const scrollBarWidth = this.$refs.scrollBar.offsetWidth;
      const controllerWidth = this.$refs.controller.offsetWidth;
      this.maxLeft = scrollBarWidth - controllerWidth;

      if (this.controllerLeft > this.maxLeft) {
        this.controllerLeft = this.maxLeft;
      }
      if (this.controllerLeft < this.minLeft) {
        this.controllerLeft = this.minLeft;
      }
    },
    handleMouseStart(e) {
      e.preventDefault();
      this.startPosX = e.clientX;
      this.startLeft = this.controllerLeft;
      this.isDragging = true;
    },
    handleMouseMove(e) {
      if (this.isDragging) {
        const deltaX = e.clientX - this.startPosX;
        let newLeft = this.startLeft + deltaX;
        if (newLeft > this.maxLeft) {
          newLeft = this.maxLeft;
        }
        if (newLeft < this.minLeft) {
          newLeft = this.minLeft;
        }
        this.controllerLeft = newLeft;  
        const mapElement = this.$refs.map;
        mapElement.scrollLeft = (newLeft / this.maxLeft) * (mapElement.scrollWidth - mapElement.clientWidth);
      }
    },
    handleMouseUp() {
      this.isDragging = false;
    },
    handleTouchStart(e) {
      e.preventDefault();
      const touch = e.touches[0];
      this.startPosX = touch.clientX;
      this.startLeft = this.controllerLeft;
      this.isDragging = true;
    },
    handleTouchMove(e) {
      if (this.isDragging) {
        const touch = e.touches[0];
        const deltaX = touch.clientX - this.startPosX;
        let newLeft = this.startLeft + deltaX;
        if (newLeft > this.maxLeft) {
          newLeft = this.maxLeft;
        }
        if (newLeft < this.minLeft) {
          newLeft = this.minLeft;
        }
        this.controllerLeft = newLeft;
        const mapElement = this.$refs.map;
        mapElement.scrollLeft = (newLeft / this.maxLeft) * (mapElement.scrollWidth - mapElement.clientWidth);
      }
    },
    handleTouchEnd() {
      this.isDragging = false;
    }
  },
  data() {
    return {
      featureId: null,
      mapId: -1,
      timerId: null,
      serviceId: 0,
      lastX: 0,
      isDown: false,
      limitX: 0,
      initX: 0,
      per: 0,
      scroll: null,
      handle: null,
      currentBalloon: null,
      radioOpen: -1,
      world: [
        { name: 'US (West)', active: true, balloon: '<b>US (West) Region : </b><br/>United States, Canada, Mexico, etc.' },
        { name: 'US (East)', active: false, balloon: null },
        { name: 'Germany', active: true, balloon: '<b>Germany Region : </b><br/>Europe (21 EU countries), Africa, Middle East, etc.' },
        { name: 'Korea', active: true, balloon: null },
        { name: 'Hong Kong', active: false, balloon: '<b>Hong Kong Region : </b><br/>Hong Kong, Taiwan, Macao, Vietnam, Philippines, etc.' },
        { name: 'Japan', active: true, balloon: '<b>Japan Region : </b><br/>Japan' },
        { name: 'Singapore', active: true, balloon: '<b>Singapore Region : </b><br/>Indonesia, Malaysia, Thailand, Cambodia, Vietnam, etc.' },
        { name: 'Thailand', active: false, balloon: null },
        { name: 'Vietnam', active: false, balloon: null },
        { name: 'Taiwan', active: false, balloon: null }
      ],
      isDragging: false,
      startPosX: 0,
      startLeft: 0,
      controllerLeft: 0,
      minLeft: 0,
      maxLeft: 0 
    };
  },
  mounted() {
    window.addEventListener('touchstart', this.removeBalloon);
    this.calculateMaxLeft();
    window.addEventListener('resize', this.calculateMaxLeft);
  },
  beforeDestroy() {
    window.removeEventListener('touchstart', this.removeBalloon);
    window.removeEventListener('resize', this.calculateMaxLeft);
  }
};
</script>

<style lang="less"></style>
